import { observable } from "mobx";
import { Type } from "class-transformer";
import RecreationPermittedActionResponse from "./recreationPermittedActionResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RejectedCustomerRefundCandidatePermittedActionsResponse {
  @observable
  @Type(() => RecreationPermittedActionResponse)
  recreation!: RecreationPermittedActionResponse;
}
